<template>
  <layout-main-inner title="检测报告">
    <layout-card-wrap hasHeaderSlot
                      v-loading="loading">
      <template slot="title">
        <el-button type="primary"
                   icon="el-icon-plus"
                   @click="createReport">新建检测报告</el-button>
      </template>
      <div slot="form">
        <assign-ent-select style="width: 180px;margin-right: 10px;"
                           immediate
                           v-model="config.vendorId"
                           :option="{}"
                           :callback="() => {handleCurrentChange(1)}" />
        <el-input placeholder="请输入检验编号"
                  v-model="config.declarationCode"
                  style="width: 200px">
          <el-button slot="append"
                     icon="el-icon-search"
                     @click="handleCurrentChange(1)"></el-button>
        </el-input>
      </div>
      <el-table border
                :data="list">
        <el-table-column label="检验编号"
                         fixed="left"
                         min-width="140">
          <template slot-scope="{row}">
            <span>{{row.certNumber || row.declarationCode}}</span>
          </template>
        </el-table-column>
        <el-table-column label="证书图片"
                         min-width="280px">
          <template slot-scope="{row}">
            <image-list :fileList="row.certFile" />
          </template>
        </el-table-column>
        <el-table-column label="检测人员"
                         min-width="80"
                         prop="inspector">
        </el-table-column>
        <el-table-column label="检测地址"
                         min-width="160"
                         prop="inspectionAddress">
        </el-table-column>
        <el-table-column label="检测时间"
                         width="100">
          <template slot-scope="{row}"> {{ row.inspectionTime | dateformat('YYYY-MM-DD')}} </template>
        </el-table-column>
        <el-table-column label="企业名称"
                         min-width="160"
                         prop="vendorName"></el-table-column>
        <!-- <el-table-column label="管理/服务机构"
                         width="140"
                         prop="regulatorName">
        </el-table-column> -->
        <el-table-column label="操作"
                         fixed="right"
                         width="90">
          <template slot-scope="{row}">
            <el-button type="text"
                       @click="editReport(row)">编辑</el-button>
            <el-button type="text"
                       @click="deleteCert(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <template slot="footer">
        <el-pagination background
                       @current-change="handleCurrentChange"
                       :current-page.sync="config.pageNum"
                       :page-size="config.pageSize"
                       layout="total, prev, pager, next"
                       :total="total">
        </el-pagination>
      </template>
    </layout-card-wrap>
    <inspect-report-modal ref="modal"
                          :fetch="fetchList" />
  </layout-main-inner>
</template>
<script>
import ImageList from '@/components/public/image-list.vue'
import { mapState } from 'vuex'
import AssignEntSelect from '../../components/business/assign-ent-select.vue'
import InspectReportModal from './inspect-report-modal.vue'
export default {
  name: 'certificate-list',
  components: { AssignEntSelect, InspectReportModal, ImageList },
  props: {},
  data () {
    return {
      loading: false,
      config: { pageNum: 1, pageSize: 10, declarationCode: '', vendorId: null, inspectReportSource: 2 },
      list: [],
      total: 0
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo,
      query: state => state.common.query
    })
  },
  methods: {
    createReport () {
      const regulatorId = this.userInfo.orgId
      this.$refs.modal.init({ regulatorId })
    },
    editReport (row) {
      this.$refs.modal.init(row)
    },
    handleCurrentChange (current) {
      this.config.pageNum = current
      this.fetchList()
    },
    fetchList () {
      this.loading = true
      this.$store.commit('common/setQuery', this.config)
      this.$store.dispatch('inspect/getinspectreports', {
        payload: this.config,
        success: (res) => {
          this.loading = false
          this.total = res.data.total
          this.list = res.data.records.map(item => {
            item.certFile = item.certFile.split(',').map(o => ({ url: o }))
            // item.regulatorId = '1233'
            return item
          })
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    deleteCert (row) {
      this.$confirm('此操作将永久删除该检测报告, 是否继续?', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' })
        .then(() => {
          this.loading = true
          this.$store.dispatch('inspect/deleteinspectreport', {
            payload: { inspectReportId: row.inspectReportId, vendorId: row.vendorId },
            success: (res) => {
              this.loading = false
              this.fetchList()
            },
            fail: () => {
              this.loading = false
            }
          })
        })
    }
  },
  created () {
    if (this.query) {
      this.config = { ...this.config, ...this.query }
    }
  },
  mounted () {
    this.fetchList()
  }
}
</script>
